/**
 * Created by linjianxi on 2017/1/18.
 */
import * as types from './mutation-type'
// import * as http from '../../../utils/common'
import cookie from '../../../utils/cookie'
import { GetRedCouponList, ReceiveRedCoupon } from '../../../utils/environconfig'

/**
 * 获取红包列表
 * @param commit
 * @param params
 */
/* export const getRedList = ({commit}, params) => {
 http.post({
 url: '/api/myaccount/GetRedCouponList',
 data: params.data,
 succ: function (res) {
 console.log(res)
 if (res.result === 1) {
 commit(types.GET_RED_LIST, res.data.Data)
 } else {
 alert(res.message)
 }
 }
 }, params._this.$store.commit)
 } */
/**
 * 获取红包列表
 * @param commit
 * @param params
 */
/* export const getRedList = ({commit}, params) => {
 http.post({
 url: '/proxy/trans',
 data: {
 domain: 7,
 api: 6,
 method: 'json',
 param: encodeURIComponent("{'QueryType': '" + params.data.QueryType + "', 'reqtype': 'reqtype', 'Pageindex': '" + params.data.Pageindex + "', 'PageSize': '" + params.data.PageSize + "', 'device_id': '" + cookie('device_id') + "', 'ctoken': '" + cookie('ctoken') + "', 'utoken': '" + cookie('utoken') + "'}")
 },
 succ: function (res) {
 console.log(res)
 if (res.result === 1) {
 commit(types.GET_RED_LIST, res.data.Data)
 } else {
 alert(res.message)
 }
 }
 }, params._this.$store.commit)
 } */
export const getRedList = ({commit}, params) => {
  console.log(GetRedCouponList)
  $.ajax({
    url: GetRedCouponList,
   // url: 'http://livemoneyapitest.eastmoney.com/api/myaccount/GetRedCouponList',
    data: 'QueryType=' + params.data.QueryType + '&reqtype=reqtype' + '&Pageindex=' + params.data.Pageindex + '&PageSize=' + params.data.PageSize + '&device_id=' + cookie('device_id') + '&ctoken=' + cookie('ctoken') + '&utoken=' + cookie('utoken'),
    type: 'get',
    timeout: 15000,
    dataType: 'jsonp',
    jsonp: 'callback',
    success: function (res) {
      console.log(res)
      if (res.result === 1) {
        commit(types.GET_RED_LIST, res.data.Data)
      } else {
        alert(res.message)
      }
    }
  })
}
/**
 * 激活红包
 * @param commit
 * @param params
 */
/* export const activeRed = ({commit}, params) => {
 http.post({
 url: '/proxy/trans',
 data: {
 domain: 7,
 api: 5,
 method: 'json',
 param: encodeURIComponent("{'reqtype': 'reqtype', 'RefPkids': '" + params.data.RefPkids + "', 'device_id': '" + cookie('device_id') + "', 'ctoken': '" + cookie('ctoken') + "', 'utoken': '" + cookie('utoken') + "'}")
 },
 succ: function (res) {
 console.log(res)
 if (res.result === 1) {
 getRedList(commit, params)
 }
 }
 })
 } */
export const activeRed = ({commit}, params) => {
  console.log(params)
  $.ajax({
    url: ReceiveRedCoupon,
  //  url: 'http://livemoneyapitest.eastmoney.com/api/myaccount/ReceiveRedCoupon',
    data: 'reqtype=reqtype' + '&RefPkids=' + params.data.RefPkids + '&device_id=' + cookie('device_id') + '&ctoken=' + cookie('ctoken') + '&utoken=' + cookie('utoken'),
    type: 'get',
    timeout: 15000,
    dataType: 'jsonp',
    jsonp: 'callback',
    success: function (res) {
      console.log(res)
      if (res.result === 1) {
        getRedList({commit}, {data: {QueryType: params._this.type, reqtype: 'reqtype', Pageindex: 1, PageSize: 100}, _this: params._this})
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/vuex/modules/packet/actions.js